import { render, staticRenderFns } from "./Gastronomaniac.vue?vue&type=template&id=63e2ae40&scoped=true&"
import script from "./Gastronomaniac.vue?vue&type=script&lang=js&"
export * from "./Gastronomaniac.vue?vue&type=script&lang=js&"
import style0 from "./Gastronomaniac.vue?vue&type=style&index=0&id=63e2ae40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e2ae40",
  null
  
)

export default component.exports